import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<'body', MessageDescriptor> = defineMessages({
	body: {
		id: 'post-office.adminhub-pls-contact-sales.body',
		defaultMessage: 'Make sure you’re on the right plan. <Link>Contact sales</Link>',
		description:
			'Banner text inviting an Admin Hub user to check their plan; <Link> wraps the contact sales call to action',
	},
});
